<template>
  <li class="cart-nav onhover-dropdown" :class="{ 'onhover-dropdown-active': isshowCart }"  @click="cart_open()">
    <div class="cart-box" >
      <feather type="shopping-cart" varient="dark"></feather>
      <span class="badge badge-pill badge-primary">{{cart.length}}</span>
    </div>
    <div class="cart-dropdown onhover-show-div text-dark" :class="{ active: isshowCart }" style="cursor: auto;">
      <h6 class="f-18 mb-0 dropdown-title">{{$t("lbl_EMPBE_Cart")}}</h6>
      <ul>
        <!-- <li>
          <button class="btn quantity-left-minus" type="button" @click="clearCart()">clear cart</button>
        </li> -->
        <li class="mt-0" v-for="(item,index) in cart" :key="index">
          <div class="media">
            <!-- <img class="img-fluid b-r-5 mr-3 img-60" :src="getImgUrl(item.images[0])" alt="" /> -->
            <div class="media-body">
              <span>{{langid == '1252' ? item.titleEn : langid == '950' ? item.titleTc : item.titleSc}}</span>
              <div class="qty-box">
                <div class="input-group">
                  <span class="input-group-prepend">
                    <button class="btn quantity-left-minus" type="button" data-type="minus" data-field="" :disabled="item.stockPerAccount == 1" :style="item.stockPerAccount == 1 ? 'cursor: not-allowed;':''"
                      v-on:click="decrement(item)">
                      -
                    </button>
                  </span>
                  <input class="form-control input-number" type="text" name="quantity" :value="item.quantity" disabled/><span
                    class="input-group-prepend">
                    <button class="btn quantity-right-plus" type="button" data-type="plus" data-field=""
                      v-on:click="increment(item)" :disabled="item.stockPerAccount == 1" :style="item.stockPerAccount == 1 ? 'cursor: not-allowed;':''">
                      +
                    </button></span>
                </div>
              </div>
              <h6 class="font-primary">USD${{item.priceUSD}} / RMB¥{{ item.priceRMB }}</h6>
            </div>
            <div class="close-circle">
              <a @click="removeProduct(item)" href="#" class="bg-danger">
                <feather type="x"></feather>
              </a>
            </div>
          </div>
        </li>
        <li class="total">
          <h6 class="mb-0 f-16">
            {{ $t("lbl_EMPBE_Total") }} : <span class="f-right">USD${{getAmountUSD}} / RMB¥{{ getAmountRMB }}</span>
          </h6>
        </li>
        <li class="text-center">
          <!-- <router-link class="d-block mb-3 f-w-700 view-cart" :to="'/ecommerce/cart'">
            前往购物车
          </router-link> -->
          <router-link :to="'/ecommerce/cart'" class="btn btn-secondary view-checkout" @click="cart_open()" v-bind:t_label="'EMPBE_Header_GotoCart'">
            {{$t("lbl_EMPBE_GoToCart")}}
          </router-link>
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Cart',
  data() {
    return {

    };
  },
  computed: {
    ...mapState({
      cart: state => state.paymentItem.cart,
      isshowCart: state => state.paymentItem.isshowCart,
      getAmountUSD() {
        return this.totalAmount = this.$store.getters['paymentItem/getTotalAmount_USD'];
      },
      getAmountRMB() {
        return this.totalAmount = this.$store.getters['paymentItem/getTotalAmount_RMB'];
      }
    }),
    langid() {
      return localStorage.getItem("currentLangId")
    }
  },
  methods: {
    cart_open() {
      this.$store.dispatch('paymentItem/toggleCart');
    },
    clearCart() {
      this.$store.dispatch('paymentItem/clearCart');
    },
    getImgUrl(path) {
      return require('../../assets/images/' + path);
    },
    removeProduct: function (product) {
      this.$store.dispatch('paymentItem/removeProduct', product);
    },
    increment(product, qty = 1) {
      this.$store.dispatch('paymentItem/updateCartQuantity', { 'product': product, 'qty': qty });
    },
    decrement(product, qty = -1) {
      this.$store.dispatch('paymentItem/updateCartQuantity', { 'product': product, 'qty': qty });
    },
  },
};

</script>
<style>
.onhover-dropdown-active .onhover-show-div:before {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
  content: "";
  top: -7px;
  position: absolute;
  left: 10px;
  z-index: 2;
}

.onhover-dropdown-active .onhover-show-div:after {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #d7e2e9;
  content: "";
  top: -7px;
  position: absolute;
  left: 10px;
  z-index: 1;
}

.onhover-dropdown-active .onhover-show-div {
  opacity: 1;
  -webkit-transform: translateY(0px);
  transform: translateY(0px);
  visibility: visible;
  border-radius: 5px;
  overflow: hidden;
}

.outside {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  cursor: auto;
}
</style>